export default __webpack_public_path__ + "static/media/Belt of Tranquility.7b506012.jpg";